export const _$ = (id) => {
    const element = document.getElementById(id);
    if (element) return document.getElementById(id);
};
export const _addText = (id, value) => {
    if (!_$(id)) return;
    return _$(id).innerHTML += value;
};
export const _setText = (id, value) => {
    if (!_$(id)) return;
    return _$(id).innerHTML = value;
};
export const _removeClass = (id, className) => {
    if (!_$(id)) return;
    switch (typeof (className)) {
        case 'string':
            return _$(id).classList.remove(className);
        case 'object':
            for (const i in className) {
                if (className[i]) {
                    _$(id).classList.remove(className[i]);
                }
            }
            break;
        default:
            return _$(id).classList.remove(className);
    }
};
export const _addClass = (id, className) => {
    if (!_$(id)) return;
    switch (typeof (className)) {
        case 'string':
            return _$(id).classList.add(className);
        case 'object':
            for (const i in className) {
                if (className[i]) {
                    _$(id).classList.add(className[i]);
                }
            }
            break;
        default:
            return _$(id).classList.add(className);
    }
};
export const _spinner = (id) => {
    if (!_$(id)) return;
    _$(id).innerHTML += '<div class="spinner-border spinner-border-sm text-light ml-1" role="status"><span class="sr-only">Loading...</span></div>';
    _$(id).disabled = true;
};
export const _removeModals = () => {
    const modals = document.getElementsByClassName('modal-backdrop');
    for (const i in modals) {
        if (typeof (modals[i]) == 'object') {
            modals[i].classList.remove('show');
            modals[i].style.display = 'none';
        }
    }
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');
};

export const _hide = (id) => {
    if (!_$(id)) return;
    _$(id).style.display = 'none';
};
